import { render, staticRenderFns } from "./mapspartout-custom-gallery.vue?vue&type=template&id=224cc5f4&scoped=true"
import script from "./mapspartout-custom-gallery.vue?vue&type=script&lang=js"
export * from "./mapspartout-custom-gallery.vue?vue&type=script&lang=js"
import style0 from "./mapspartout-custom-gallery.vue?vue&type=style&index=0&id=224cc5f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224cc5f4",
  null
  
)

export default component.exports